var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isSample)?_c('abstract-dialog-index',[_c(_vm.getCurrentDialog,{tag:"component",attrs:{"bindParams":_vm.options},model:{value:(_vm.currentModal),callback:function ($$v) {_vm.currentModal=$$v},expression:"currentModal"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }